import { render, staticRenderFns } from "./NavbarBusiness.vue?vue&type=template&id=5b1de589&scoped=true&"
import script from "./NavbarBusiness.vue?vue&type=script&lang=js&"
export * from "./NavbarBusiness.vue?vue&type=script&lang=js&"
import style0 from "./NavbarBusiness.vue?vue&type=style&index=0&id=5b1de589&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1de589",
  null
  
)

export default component.exports